/* SIFI BEAUVOIS — Product Hero — interactions (B1) + switch de cadran en fondu (B2) */
(function () {
  'use strict';

  var switching = false;
  var productHeroTitleRevealObserver = null;

  /* Config panier posee par le Liquid sur #sifiCartDrawer (cart-drawer.liquid) :
     URLs sensibles a la langue (/en/...). Replis = valeurs historiques. */
  var sbCartCfgEl = document.getElementById('sifiCartDrawer');
  function sbCartCfg(nom, repli) {
    return (sbCartCfgEl && sbCartCfgEl.getAttribute(nom)) || repli;
  }

  // --- Apparition du titre du Product Hero ---
  function getProductHeroTitleRevealElements(root) {
    var scope = root || document;

    return Array.prototype.slice.call(
      scope.querySelectorAll(
        '[data-sb-product-hero-title-reveal]:not([data-sb-product-hero-title-reveal-ready])'
      )
    );
  }

  function showProductHeroTitleReveals(elements, animate) {
    elements.forEach(function (element) {
      element.setAttribute(
        'data-sb-product-hero-title-reveal-ready',
        'true'
      );
    });

    function reveal() {
      elements.forEach(function (element) {
        element.classList.add('is-visible');
      });
    }

    if (!animate) {
      reveal();
      return;
    }

    /* Laisse le navigateur peindre l'état initial masqué avant
       d'ajouter is-visible, afin de conserver l'animation même
       lorsqu'elle démarre automatiquement sur mobile. */
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(reveal);
    });
  }

  function initProductHeroTitleReveals(root, showImmediately) {
    var elements = getProductHeroTitleRevealElements(root);
    if (!elements.length) return;

    var reduceMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var mobileImmediate =
      window.matchMedia &&
      window.matchMedia('(max-width: 640px)').matches;

    if (
      showImmediately ||
      mobileImmediate ||
      reduceMotion ||
      !('IntersectionObserver' in window)
    ) {
      showProductHeroTitleReveals(
        elements,
        (showImmediately || mobileImmediate) && !reduceMotion
      );
      return;
    }

    if (!productHeroTitleRevealObserver) {
      productHeroTitleRevealObserver = new IntersectionObserver(
        function (entries, observer) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;

            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        {
          threshold: 0.18,
          rootMargin: '0px 0px -8% 0px'
        }
      );
    }

    elements.forEach(function (element) {
      element.setAttribute(
        'data-sb-product-hero-title-reveal-ready',
        'true'
      );
      productHeroTitleRevealObserver.observe(element);
    });
  }

  // --- Ajout au panier ---
  function initAddToCart() {
    document.querySelectorAll('[data-sifi-add]').forEach(function (btn) {
      if (btn.dataset.sbAddInit === '1') return;
      btn.dataset.sbAddInit = '1';
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-variant-id');
        if (!id) return;
        btn.disabled = true;
        fetch(sbCartCfg('data-url-add', '/cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) { throw new Error('cart-add-' + r.status); } return r.json(); })
          .then(function () { if (window.sifiOpenCart) { window.sifiOpenCart(); btn.disabled = false; } else { window.location.href = sbCartCfg('data-url-cart-page', '/cart'); } })
          .catch(function () { btn.disabled = false; });
      });
    });
  }

  // --- Me prévenir : descente fluide vers la newsletter ---
  function initNewsletterScroll() {
    document.querySelectorAll('.sb-product-hero .sb-pos-btn--scroll[href^="#"]').forEach(function (link) {
      if (link.dataset.sbNewsletterScrollInit === '1') return;
      link.dataset.sbNewsletterScrollInit = '1';

      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href') || '';
        var targetId = href.charAt(0) === '#' ? href.slice(1) : '';
        var target = targetId ? document.getElementById(targetId) : null;

        if (!target) return;

        event.preventDefault();

        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });
    });
  }


  // --- Caractéristiques : aperçu en fondu + déploiement ---
  function initProductHighlights() {
    document.querySelectorAll('[data-sb-product-highlights]').forEach(function (highlights) {
      if (highlights.dataset.sbHighlightsInit === '1') return;
      highlights.dataset.sbHighlightsInit = '1';

      var content = highlights.querySelector('[data-sb-product-highlights-content]');
      var toggle = highlights.querySelector('[data-sb-product-highlights-toggle]');
      var label = highlights.querySelector('.sb-product-highlights__toggle-label');
      var heroEl = highlights.closest('.sb-product-hero');
      if (!content || !toggle || !label) return;

      function getCollapsedHeight() {
        var value = parseFloat(
          window.getComputedStyle(content).getPropertyValue('--sb-highlights-collapsed-height')
        );
        return Number.isFinite(value) ? value : 92;
      }

      function setExpanded(expanded) {
        var collapsedHeight = getCollapsedHeight();
        var fullHeight = content.scrollHeight;

        if (expanded) {
          content.style.maxHeight = collapsedHeight + 'px';
          content.offsetHeight;

          highlights.classList.add('is-expanded');
          if (heroEl) heroEl.classList.add('is-highlights-expanded');
          toggle.setAttribute('aria-expanded', 'true');
          label.textContent = toggle.getAttribute('data-txt-less') || 'Réduire';

          content.style.maxHeight = fullHeight + 'px';

          if (
            window.matchMedia &&
            window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ) {
            content.style.maxHeight = 'none';
          }
        } else {
          content.style.maxHeight = fullHeight + 'px';
          content.offsetHeight;

          highlights.classList.remove('is-expanded');
          if (heroEl) heroEl.classList.remove('is-highlights-expanded');
          toggle.setAttribute('aria-expanded', 'false');
          label.textContent = toggle.getAttribute('data-txt-more') || 'Voir plus';

          content.style.maxHeight = collapsedHeight + 'px';
        }
      }

      content.style.maxHeight = getCollapsedHeight() + 'px';

      toggle.addEventListener('click', function () {
        setExpanded(!highlights.classList.contains('is-expanded'));
      });

      content.addEventListener('transitionend', function (event) {
        if (
          event.propertyName === 'max-height' &&
          highlights.classList.contains('is-expanded')
        ) {
          content.style.maxHeight = 'none';
        }
      });
    });
  }

  // --- Hero : galerie + nom de variante ---
  var heroThumbsRevealedOnce = false;

  function initHero() {
    document.querySelectorAll('.sb-product-hero').forEach(function (heroEl) {
      if (heroEl.dataset.sbHeroGalleryInit === '1') return;
      heroEl.dataset.sbHeroGalleryInit = '1';

      var images = Array.prototype.slice.call(heroEl.querySelectorAll('.sb-product-hero__image'));
      var progressButtons = Array.prototype.slice.call(heroEl.querySelectorAll('.sb-product-hero__mobile-progress-btn'));
      var thumbs = Array.prototype.slice.call(heroEl.querySelectorAll('[data-sb-hero-thumb]'));
      var prevBtn = heroEl.querySelector('[data-sb-hero-prev]');
      var nextBtn = heroEl.querySelector('[data-sb-hero-next]');
      var current = 0;
      if (!images.length) return;

      function showImage(index) {
        if (index < 0) index = images.length - 1;
        if (index >= images.length) index = 0;
        current = index;
        images.forEach(function (img) {
          img.classList.toggle('is-active', parseInt(img.getAttribute('data-index'), 10) === current);
        });
        progressButtons.forEach(function (button) {
          var isActive = parseInt(button.getAttribute('data-index'), 10) === current;
          button.classList.toggle('is-active', isActive);
          if (isActive) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
        thumbs.forEach(function (thumb) {
          var isActive = parseInt(thumb.getAttribute('data-index'), 10) === current;
          thumb.classList.toggle('is-active', isActive);
          if (isActive) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
      }

      /* API vivante de la galerie — consommée par les flèches et les
         vignettes desktop (ci-dessous) et par la vue 3D (product-3d.js,
         qui enveloppe show pour sortir de la 3D à chaque navigation).
         Recréée à chaque switch de variante : le hero est remplacé par
         switchVariant puis ré-initialisé ici. */
      heroEl.sbGalleryApi = {
        count: images.length,
        current: function () { return current; },
        show: showImage
      };

      /* ⚠️ TOUTE navigation d'interface passe par l'API (heroEl.sbGalleryApi),
         JAMAIS par showImage en direct : product-3d.js enveloppe api.show
         pour refermer la vue 3D à chaque changement d'image. Un appel direct
         court-circuiterait l'enveloppe — la photo changerait DERRIÈRE la 3D
         restée ouverte (bogue attrapé au banc du 07/08, invisible tant que
         la 3D n'existait pas). showImage reste la mécanique interne que
         l'API expose. */
      function goTo(index) {
        var api = heroEl.sbGalleryApi;
        if (api && typeof api.show === 'function') api.show(index);
        else showImage(index);
      }

      progressButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          var index = parseInt(button.getAttribute('data-index'), 10) || 0;

          /* Desktop comme mobile : fondu sur place (depuis le 26/07 la
             galerie desktop est le même cadre empilé que le mobile). */
          goTo(index);
        });
      });

      /* Flèches + vignettes desktop (07/08/2026, référence Atelier Wen).
         Tout passe par showImage : la vue 3D, qui enveloppe l'API, se
         referme donc d'elle-même sur chacune de ces navigations. */
      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          goTo(parseInt(thumb.getAttribute('data-index'), 10) || 0);
        });
      });

      /* Révélation étagée des vignettes à l'arrivée — même courbe que les
         reveals du site, décalage porté par le JS (pas de transition-delay
         CSS : il retarderait aussi le changement d'état actif ensuite).
         Au premier chargement seulement : après un switch de variante, les
         vignettes reviennent sans animation, comme les titres
         (initProductHeroTitleReveals est appelé avec showImmediately). */
      if (thumbs.length) {
        if (!heroThumbsRevealedOnce) {
          heroThumbsRevealedOnce = true;
          thumbs.forEach(function (thumb, i) {
            window.setTimeout(function () {
              thumb.classList.add('is-visible');
            }, 340 + i * 90);
          });
        } else {
          thumbs.forEach(function (thumb) { thumb.classList.add('is-visible'); });
        }
      }

      var touchStartX = 0;
      var imageWrap = heroEl.querySelector('.sb-product-hero__image-wrap');
      if (imageWrap) {
        imageWrap.addEventListener('touchstart', function (e) {
          if (e.touches && e.touches.length) touchStartX = e.touches[0].clientX;
        }, { passive: true });
        imageWrap.addEventListener('touchend', function (e) {
          if (!e.changedTouches || !e.changedTouches.length) return;
          var diff = e.changedTouches[0].clientX - touchStartX;
          if (Math.abs(diff) > 42) goTo(diff < 0 ? current + 1 : current - 1);
        }, { passive: true });
      }

      var variantNameEl = heroEl.querySelector('[data-sb-variant-name]');
      if (variantNameEl) {
        var defaultName = variantNameEl.getAttribute('data-default-name') || '';
        Array.prototype.slice.call(heroEl.querySelectorAll('[data-sb-variant-name]')).forEach(function (thumb) {
          if (thumb === variantNameEl) return;
          var name = thumb.getAttribute('data-sb-variant-name') || '';
          thumb.addEventListener('mouseenter', function () { if (name) variantNameEl.textContent = name; });
          thumb.addEventListener('mouseleave', function () { variantNameEl.textContent = defaultName; });
        });
      }
    });

  }


  /* (Le suivi « segment actif selon l'image au centre » du desktop a été
     retiré le 26/07 : la galerie desktop est devenue le même cadre empilé
     que le mobile — c'est showImage qui tient les segments à jour.) */

  /* --- Fondu tenu du switch de cadran (15/08/2026, demande Naji : « même
     principe que l'aperçu du méga-menu — seule la couleur du cadran bouge »).
     Montage détaillé dans product_hero.css, chapitre SWITCH DE CADRAN.
     L'essentiel : l'image affichée est détachée AVANT le remplacement du hero
     (le nœud vivant, pas un clone — un clone re-décoderait le fichier et
     pourrait laisser un blanc d'une frame), réinsérée APRÈS en couche tenue
     opaque, et la nouvelle image monte par-dessus avec la transition de la
     galerie. Le tout dans le même tour de boucle : aucun flash possible.
     Pas de fondu si la 3D est ouverte (le modèle couvre les photos — on
     garde la coupure d'aujourd'hui) ni en mouvement réduit. */
  function sbCaptureVariantSwap(wrapper) {
    try {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return null;
    } catch (e) { /* matchMedia absent : on fond quand même */ }
    if (wrapper.querySelector('.sb-product-hero.sb-is-3d')) return null;

    var old = wrapper.querySelector('.sb-product-hero__image.is-active');
    if (!old || !old.parentNode) return null;

    /* Le cadrage est copié EN LIGNE depuis l'état calculé : la 1re image
       (contain + 11 % + fond gris sur desktop) et les autres (cover) n'ont
       pas le même rendu, et la couche doit figer exactement celui de l'image
       qu'elle remplace. Lire AVANT de changer la classe : après, l'état
       calculé serait celui de la couche tenue, plus celui de l'image. */
    var calc = window.getComputedStyle(old);
    var fit = calc.objectFit;
    var position = calc.objectPosition;
    var padding = calc.padding;
    var fond = calc.backgroundColor;

    old.parentNode.removeChild(old);
    old.className = 'sb-product-hero__swap-held';
    old.removeAttribute('data-index');
    old.removeAttribute('fetchpriority');
    old.setAttribute('alt', '');
    old.setAttribute('aria-hidden', 'true');
    old.style.objectFit = fit;
    old.style.objectPosition = position;
    old.style.padding = padding;
    old.style.backgroundColor = fond;
    return old;
  }

  function sbApplyVariantSwap(wrapper, held) {
    if (!held) return;
    var wrap = wrapper.querySelector('.sb-product-hero__image-wrap');
    var incoming = wrapper.querySelector('.sb-product-hero__image.is-active');
    if (!wrap || !incoming) return;

    /* ⚠️ EN DERNIER, jamais en tête : une règle CSS cible
       « __image-wrap > __image:first-child » — un étranger en premier enfant
       volerait le :first-child à la vraie première image et changerait son
       cadrage pendant tout le fondu. */
    wrap.appendChild(held);

    /* Départ à 0 sans transition, reflow pour graver l'état, puis montée par
       la transition de la galerie elle-même (.5s mobile / .7s desktop —
       aucune durée nouvelle). is-swap-live ne garde que le z-index. */
    incoming.classList.add('is-swap-start');
    void incoming.offsetWidth;
    incoming.classList.remove('is-swap-start');
    incoming.classList.add('is-swap-live');

    var libere = false;
    var minuterie = 0;

    function liberer() {
      if (libere) return;
      libere = true;
      window.clearTimeout(minuterie);
      incoming.classList.remove('is-swap-live');
      if (held.parentNode) held.parentNode.removeChild(held);
    }

    incoming.addEventListener('transitionend', function onEnd(e) {
      if (e.target !== incoming || e.propertyName !== 'opacity') return;
      incoming.removeEventListener('transitionend', onEnd);
      liberer();
    });

    /* Filet : au-delà du fondu le plus lent (.7s), on libère quoi qu'il
       arrive — un transitionend peut se perdre (onglet caché, navigation
       dans la galerie en plein fondu, nouveau switch). Un second switch
       pendant le fondu est déjà sûr : le remplacement innerHTML emporte la
       couche tenue, et liberer() ne touche plus rien (gardes parentNode). */
    minuterie = window.setTimeout(liberer, 1000);
  }

  // --- B2 : switch de cadran en fondu, sans rechargement ---
  function switchVariant(variantId) {
    if (switching || !variantId) return;
    var wrapper = document.querySelector('[data-sb-product-hero-wrapper]');
    if (!wrapper) { window.location.href = window.location.pathname + '?variant=' + encodeURIComponent(variantId); return; }
    var productUrl = wrapper.getAttribute('data-product-url') || window.location.pathname;
    var sectionId = wrapper.getAttribute('data-section-id');
    if (!sectionId) { window.location.href = productUrl + '?variant=' + encodeURIComponent(variantId); return; }

    switching = true;

    var url = productUrl + '?variant=' + encodeURIComponent(variantId) + '&section_id=' + encodeURIComponent(sectionId);
    fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('Network');
      return r.text();
    }).then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var newWrap = tmp.querySelector('[data-sb-product-hero-wrapper]');
      if (!newWrap) throw new Error('No wrapper');

      /* Capture du fondu tenu AVANT le remplacement — même tour de boucle
         que le remplacement et la réinsertion : aucune frame entre les deux. */
      var swapHeld = sbCaptureVariantSwap(wrapper);

      wrapper.innerHTML = newWrap.innerHTML;

      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', variantId);
        window.history.pushState({}, '', u.toString());
      } catch (e) {}

      initHero();
      initAddToCart();
      initNewsletterScroll();
      initProductHighlights();
      initProductHeroTitleReveals(wrapper, true);
      initDeliveryEstimate(wrapper);
      initHeroAccordion(wrapper);
      bindVariantSwitch();

      sbApplyVariantSwap(wrapper, swapHeld);

      document.dispatchEvent(new CustomEvent('sifi:variant-switched', { detail: { variantId: variantId }, bubbles: true }));

      switching = false;
    }).catch(function () {
      window.location.href = productUrl + '?variant=' + encodeURIComponent(variantId);
    });
  }

  function bindVariantSwitch() {
    document.querySelectorAll('[data-sb-variant-switch]').forEach(function (link) {
      if (link.dataset.sbVariantInit === '1') return;
      link.dataset.sbVariantInit = '1';
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var id = link.getAttribute('data-variant-id');
        if (id) switchVariant(id);
      });
    });
  }

  
  // --- Estimation de livraison (remplace le libellé stock "in_stock") ---
  var SB_HOLIDAY_CACHE = {};
  var SB_EU_ISO = {AT:1,BE:1,BG:1,HR:1,CY:1,CZ:1,DK:1,EE:1,FI:1,DE:1,GR:1,HU:1,IE:1,IT:1,LV:1,LT:1,LU:1,MT:1,NL:1,PL:1,PT:1,RO:1,SK:1,SI:1,ES:1,SE:1};
  var SB_ORIGIN_TZ = 'Europe/Paris'; // fuseau d'expédition (coupure de midi, comme Shopify)

  function sbPad(n){ return n < 10 ? '0' + n : '' + n; }
  function sbIsoKey(d){ return d.getFullYear() + '-' + sbPad(d.getMonth()+1) + '-' + sbPad(d.getDate()); }
  function sbEaster(y){
    var a=y%19, b=Math.floor(y/100), c=y%100, d=Math.floor(b/4), e=b%4,
        f=Math.floor((b+8)/25), g=Math.floor((b-f+1)/3), h=(19*a+b-d-g+15)%30,
        i=Math.floor(c/4), k=c%4, l=(32+2*e+2*i-h-k)%7, m=Math.floor((a+11*h+22*l)/451),
        month=Math.floor((h+l-7*m+114)/31), day=((h+l-7*m+114)%31)+1;
    return new Date(y, month-1, day);
  }
  function sbHolidaysForYear(y){
    if (SB_HOLIDAY_CACHE[y]) return SB_HOLIDAY_CACHE[y];
    var set = {};
    set[y+'-01-01']=1; set[y+'-05-01']=1; set[y+'-05-08']=1; set[y+'-07-14']=1;
    set[y+'-08-15']=1; set[y+'-11-01']=1; set[y+'-11-11']=1; set[y+'-12-25']=1;
    var e = sbEaster(y);
    [1,39,50].forEach(function(n){ var d=new Date(e.getTime()); d.setDate(d.getDate()+n); set[sbIsoKey(d)]=1; });
    SB_HOLIDAY_CACHE[y] = set;
    return set;
  }
  function sbIsBusinessDay(d){
    var day = d.getDay();
    if (day === 0 || day === 6) return false;
    if (sbHolidaysForYear(d.getFullYear())[sbIsoKey(d)]) return false;
    return true;
  }
  function sbNextDay(d){ var n = new Date(d.getTime()); n.setDate(n.getDate()+1); return n; }
  function sbAddBusinessDays(start, count){
    var d = new Date(start.getTime()), added = 0;
    while (added < count){ d = sbNextDay(d); if (sbIsBusinessDay(d)) added++; }
    return d;
  }
  function sbOriginParts(){
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: SB_ORIGIN_TZ, year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', hour12:false
      }).formatToParts(new Date());
      var o = {};
      parts.forEach(function(p){ o[p.type] = p.value; });
      return { y:parseInt(o.year,10), m:parseInt(o.month,10), d:parseInt(o.day,10), hour:parseInt(o.hour,10) };
    } catch(e){
      var now = new Date();
      return { y:now.getFullYear(), m:now.getMonth()+1, d:now.getDate(), hour:now.getHours() };
    }
  }
  function sbTransitRange(country){
    if (country === 'FR') return [1,2];
    if (SB_EU_ISO[country]) return [2,3];
    return [3,5];
  }
  function sbFmtFull(d, loc){ return new Intl.DateTimeFormat(loc || 'fr-FR', { weekday:'short', day:'numeric', month:'short' }).format(d); }
  function sbDeliveryRange(min, max, loc){
    var sameDay = min.getFullYear()===max.getFullYear() && min.getMonth()===max.getMonth() && min.getDate()===max.getDate();
    if (sameDay) return sbFmtFull(min, loc);
    return sbFmtFull(min, loc) + ' – ' + sbFmtFull(max, loc);
  }
  function initDeliveryEstimate(root){
    var scope = root || document;
    scope.querySelectorAll('[data-sb-hero-delivery]').forEach(function(box){
      var textEl = box.querySelector('[data-sb-hero-delivery-text]') || box;
      try {
        var country = (box.getAttribute('data-country') || 'FR').toUpperCase();
        var prep = parseInt(box.getAttribute('data-prep'), 10);
        if (!isFinite(prep)) prep = 1;
        var transit = sbTransitRange(country);
        var p = sbOriginParts();
        var start = new Date(p.y, p.m - 1, p.d);
        if (p.hour >= 12) start = sbNextDay(start);
        while (!sbIsBusinessDay(start)) start = sbNextDay(start);
        var min = sbAddBusinessDays(start, prep + transit[0]);
        var max = sbAddBusinessDays(start, prep + transit[1]);
        var sbLoc = document.documentElement.lang || 'fr';
        var sbTxtFree = box.getAttribute('data-txt-free') || 'Livraison gratuite';
        textEl.innerHTML = sbTxtFree + ' <strong>' + sbDeliveryRange(min, max, sbLoc) + '</strong>';
      } catch(e){ /* garde le libellé de repli "Livraison sous 3 à 5 jours" */ }
    });
  }

  // --- Accordéon services : ouverture/fermeture animée (hauteur, WAAPI) ---
  function initHeroAccordion(root) {
    var scope = root || document;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    scope.querySelectorAll('.sb-hero-acc__item').forEach(function (item) {
      if (item.dataset.sbAccInit === '1') return;
      item.dataset.sbAccInit = '1';

      var summary = item.querySelector('summary');
      var content = item.querySelector('.sb-hero-acc__content');
      if (!summary || !content) return;

      var animation = null;
      var isClosing = false;
      var isExpanding = false;

      function onFinish(open) {
        item.open = open;
        animation = null;
        isClosing = false;
        isExpanding = false;
        item.style.height = '';
        item.style.overflow = '';
      }

      function shrink() {
        isClosing = true;
        var startHeight = item.offsetHeight + 'px';
        var endHeight = summary.offsetHeight + 'px';
        if (animation) animation.cancel();
        animation = item.animate(
          { height: [startHeight, endHeight] },
          { duration: 300, easing: 'cubic-bezier(.4,0,.2,1)' }
        );
        animation.onfinish = function () { onFinish(false); };
        animation.oncancel = function () { isClosing = false; };
      }

      function expand() {
        isExpanding = true;
        var startHeight = item.offsetHeight + 'px';
        var endHeight = (summary.offsetHeight + content.offsetHeight) + 'px';
        if (animation) animation.cancel();
        animation = item.animate(
          { height: [startHeight, endHeight] },
          { duration: 300, easing: 'cubic-bezier(.4,0,.2,1)' }
        );
        animation.onfinish = function () { onFinish(true); };
        animation.oncancel = function () { isExpanding = false; };
      }

      function open() {
        item.style.height = item.offsetHeight + 'px';
        item.open = true;
        window.requestAnimationFrame(expand);
      }

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (reduce) { item.open = !item.open; return; }
        item.style.overflow = 'hidden';
        if (isClosing || !item.open) open();
        else if (isExpanding || item.open) shrink();
      });
    });
  }

  function initAll() {
    initAddToCart();
    initNewsletterScroll();
    initHero();
    initProductHighlights();
    initProductHeroTitleReveals(document, false);
    initDeliveryEstimate(document);
    initHeroAccordion(document);
    bindVariantSwitch();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initProductHeroTitleReveals(event.target, false);
  });

  window.sifiInitAddToCart = initAddToCart;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();

/* (Le feuilletage de la galerie desktop à la molette, module qui vivait ici
   du 26/07 au 07/08/2026, a été RETIRÉ à la demande de Naji : la navigation
   desktop passe désormais par les flèches et les vignettes, posées dans
   initHero. La molette est redevenue 100 % native sur toute la fiche. Si une
   interception de molette devait revenir un jour, relire l'avertissement
   qui accompagnait le module : garde panelOpen() obligatoire — les 5 classes
   body des panneaux — car le verrou overflow du body n'arrête pas un
   écouteur JS. Historique complet dans product_hero.css et le document de
   projet. ) */